export class ServiceRequestFeedbackError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ServiceRequestFeedbackError';
  }
}
